"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterComponent = exports.FieldFilter = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const field_filter_styles_1 = require("./field-filter-styles");
const filter_text_cell_1 = require("./filter-cells/filter-text-cell");
const filter_autocomplete_cell_1 = require("./filter-cells/filter-autocomplete-cell");
const filter_date_cell_1 = require("./filter-cells/filter-date-cell");
const filter_date_time_cell_1 = require("./filter-cells/filter-date-time-cell");
const filter_number_cell_1 = require("./filter-cells/filter-number-cell");
const filter_select_cell_1 = require("./filter-cells/filter-select-cell");
const filter_boolean_cell_1 = require("./filter-cells/filter-boolean-cell");
exports.FieldFilter = {
    FilterTextCell: filter_text_cell_1.FilterTextCell,
    FilterAutocompleteCell: filter_autocomplete_cell_1.FilterAutocompleteCell,
    FilterDateCell: filter_date_cell_1.FilterDateCell,
    FilterInstantDateTimeCell: filter_date_time_cell_1.FilterInstantDateTimeCell,
    FilterLocalDateTimeCell: filter_date_time_cell_1.FilterLocalDateTimeCell,
    FilterNumberCell: filter_number_cell_1.FilterNumberCell,
    FilterSelectCell: filter_select_cell_1.FilterSelectCell,
    FilterBooleanCell: filter_boolean_cell_1.FilterBooleanCell,
};
function FilterComponent({ filter, state, onChangeValue, onChangeFilterState, }) {
    const classes = field_filter_styles_1.useFilterComponentStyles();
    const { FilterComponent } = filter;
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.labelWrapper },
            react_1.default.createElement(Typography_1.default, { variant: "body1" }, filter.label)),
        react_1.default.createElement("div", { className: classes.fieldWrapper },
            react_1.default.createElement(FilterComponent, { filter: filter, disabled: false, state: state, value: state.value, onChange: onChangeValue, onChangeState: onChangeFilterState }))));
}
exports.FilterComponent = FilterComponent;
//# sourceMappingURL=field-filter-component.js.map